import React from 'react';

interface ProgressMilestonesProps {
  milestoneReached: {
    twentyFive: boolean;
    fifty: boolean;
    seventyFive: boolean;
    hundred: boolean;
  };
}

const ProgressMilestones: React.FC<ProgressMilestonesProps> = React.memo(({ milestoneReached }) => {
  return (
    <div className="progress-milestones">
      <span className={`milestone ${milestoneReached.twentyFive ? 'reached' : ''}`}>25%</span>
      <span className={`milestone ${milestoneReached.fifty ? 'reached' : ''}`}>50%</span>
      <span className={`milestone ${milestoneReached.seventyFive ? 'reached' : ''}`}>75%</span>
      <span className={`milestone ${milestoneReached.hundred ? 'reached' : ''}`}>100%</span>
    </div>
  );
});

ProgressMilestones.displayName = 'ProgressMilestones';

export default ProgressMilestones;